// extracted by mini-css-extract-plugin
module.exports = {"phone":"_6f25b66c20--phone--3bMov"};